<template>
  <ul v-if="!tableLoading" class="header__filter header__filter--full-width">
    <li class="header__filter-item">
      <a
        ref="settingsLink"
        class="header__filter-link"
        @click="$refs.settings.toggle($refs.settingsLink, 'bottom', 'left', 4)"
      >
        <i class="header__filter-icon iconoir-settings" />
        <span class="header__filter-name">Calendar fields</span>
      </a>
      <CalendarSettingsContext
        ref="settings"
        :database="database"
        :view="view"
        :fields="fields"
        :read-only="readOnly"
      />
    </li>

    <li v-if="view.start_date_field" class="header__filter-item">
      <a
        ref="labelsLink"
        class="header__filter-link"
        @click="$refs.labels.toggle($refs.labelsLink, 'bottom', 'left', 4)"
      >
        <i class="header__filter-icon iconoir-list" />
        <span class="header__filter-name">Labels</span>
      </a>
      <ViewFieldsContext
        ref="labels"
        :database="database"
        :view="view"
        :fields="fields"
        :field-options="fieldOptions"
        @update-all-field-options="updateAllFieldOptions"
        @update-field-options-of-field="updateFieldOptionsOfField"
        @update-order="orderFieldOptions"
      />
    </li>

    <li class="header__filter-item header__filter-item--full-width">
      <ViewSearch
        :view="view"
        :fields="fields"
        :store-prefix="storePrefix"
        :always-hide-rows-not-matching-search="true"
        @refresh="$emit('refresh', $event)"
      />
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'

import { notifyIf } from '@baserow/modules/core/utils/error'
import ViewFieldsContext from '@baserow/modules/database/components/view/ViewFieldsContext'
import ViewSearch from '@baserow/modules/database/components/view/ViewSearch'

import CalendarSettingsContext from '@peninsula/components/CalendarSettingsContext'

export default {
  name: 'CalendarViewHeader',
  components: { CalendarSettingsContext, ViewFieldsContext, ViewSearch },
  props: {
    database: { type: Object, required: true },
    table: { type: Object, required: true },
    view: { type: Object, required: true },
    fields: { type: Array, required: true },
    readOnly: { type: Boolean, required: true },
    storePrefix: { type: String, required: true },
  },
  emits: ['refresh'],
  computed: {
    ...mapState({ tableLoading: (state) => state.table.loading }),
    fieldOptions() {
      return this.$store.getters[
        `${this.storePrefix}view/peninsula_calendar/getAllFieldOptions`
      ]
    },
  },
  methods: {
    canUpdateFieldOptions() {
      return (
        !this.readOnly &&
        this.$hasPermission(
          'database.table.view.update_field_options',
          this.view,
          this.database.workspace.id
        )
      )
    },
    async dispatchFieldOptions(action, payload) {
      try {
        await this.$store.dispatch(
          `${this.storePrefix}view/peninsula_calendar/${action}`,
          { ...payload, readOnly: !this.canUpdateFieldOptions() }
        )
      } catch (error) {
        notifyIf(error, 'view')
      }
    },
    updateAllFieldOptions(payload) {
      return this.dispatchFieldOptions('updateAllFieldOptions', payload)
    },
    updateFieldOptionsOfField(payload) {
      return this.dispatchFieldOptions('updateFieldOptionsOfField', payload)
    },
    orderFieldOptions({ order }) {
      return this.dispatchFieldOptions('updateFieldOptionsOrder', { order })
    },
  },
}
</script>
